/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_login = /** @type {(inputs: {}) => string} */ () => {
	return `Přihlášení`
};

const da_account_login = /** @type {(inputs: {}) => string} */ () => {
	return `Log ind`
};

const de_account_login = /** @type {(inputs: {}) => string} */ () => {
	return `Anmelden`
};

const en_account_login = /** @type {(inputs: {}) => string} */ () => {
	return `Login`
};

const es_account_login = /** @type {(inputs: {}) => string} */ () => {
	return `Iniciar sesión`
};

const fr_account_login = /** @type {(inputs: {}) => string} */ () => {
	return `Connexion`
};

const hu_account_login = /** @type {(inputs: {}) => string} */ () => {
	return `Bejelentkezés`
};

const it_account_login = /** @type {(inputs: {}) => string} */ () => {
	return `Accedi`
};

const nl_account_login = /** @type {(inputs: {}) => string} */ () => {
	return `Inloggen`
};

const pl_account_login = /** @type {(inputs: {}) => string} */ () => {
	return `Zaloguj się`
};

const pt_account_login = /** @type {(inputs: {}) => string} */ () => {
	return `Entrar`
};

const sv_account_login = /** @type {(inputs: {}) => string} */ () => {
	return `Logga in`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_login = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_login(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_login", locale)
	if (locale === "cs") return cs_account_login(inputs)
	if (locale === "da") return da_account_login(inputs)
	if (locale === "de") return de_account_login(inputs)
	if (locale === "en") return en_account_login(inputs)
	if (locale === "es") return es_account_login(inputs)
	if (locale === "fr") return fr_account_login(inputs)
	if (locale === "hu") return hu_account_login(inputs)
	if (locale === "it") return it_account_login(inputs)
	if (locale === "nl") return nl_account_login(inputs)
	if (locale === "pl") return pl_account_login(inputs)
	if (locale === "pt") return pt_account_login(inputs)
	return sv_account_login(inputs)
};
export { account_login as "account.login" }